import { render, staticRenderFns } from "./phoneIos.vue?vue&type=template&id=a0d917a2&scoped=true"
import script from "./phoneIos.vue?vue&type=script&lang=js"
export * from "./phoneIos.vue?vue&type=script&lang=js"
import style0 from "./phoneIos.vue?vue&type=style&index=0&id=a0d917a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d917a2",
  null
  
)

export default component.exports